import { useState } from 'react';
import content from '../content.json';
const pub = process.env.PUBLIC_URL;
const n = content.newsletter;

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const res = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ 'form-name': 'ska-newsletter', email }).toString(),
      });
      setStatus(res.ok ? 'success' : 'error');
    } catch { setStatus('error'); }
  };

  return (
    <section style={{ position:'relative',padding:'100px 0',overflow:'hidden' }}>
      <div style={{ position:'absolute',inset:0 }}>
        <img src={`${pub}/${n.bgImage}`} alt="" style={{ width:'100%',height:'100%',objectFit:'cover' }} />
        <div style={{ position:'absolute',inset:0,background:'rgba(14,12,10,0.78)' }} />
      </div>
      <div style={{ position:'relative',zIndex:1,maxWidth:'560px',margin:'0 auto',padding:'0 48px',textAlign:'center' }}>
        <div className="reveal">
          <span className="section-label">Stay Connected</span>
          <h2 className="section-title" style={{ color:'var(--offwhite)' }}>{n.title}</h2>
          <div className="gold-line center" />
          <p style={{ fontFamily:'var(--font-body)',fontSize:'13px',lineHeight:1.8,color:'rgba(248,245,240,0.6)',marginBottom:'36px' }}>{n.text}</p>
        </div>
        <div className="reveal delay-2">
          {status === 'success' ? (
            <p style={{ fontFamily:'var(--font-title)',fontStyle:'italic',fontSize:'1.2rem',color:'var(--gold2)' }}>Welcome to the Silverkammer family ✦</p>
          ) : (
            <form name="ska-newsletter" method="POST" data-netlify="true" onSubmit={handleSubmit} style={{ display:'flex' }}>
              <input type="hidden" name="form-name" value="ska-newsletter" />
              <input type="email" name="email" value={email} onChange={e=>setEmail(e.target.value)}
                placeholder={n.placeholder} required
                style={{ flex:1,background:'rgba(248,245,240,0.1)',border:'1px solid rgba(200,150,60,0.3)',borderRight:'none',padding:'13px 18px',fontFamily:'var(--font-body)',fontSize:'13px',color:'var(--offwhite)',outline:'none' }}
              />
              <button type="submit" disabled={status==='loading'} style={{ background:'var(--gold)',border:'none',padding:'13px 24px',fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.2em',textTransform:'uppercase',color:'white',cursor:'pointer',whiteSpace:'nowrap',transition:'opacity 0.2s' }}
                onMouseEnter={e=>e.target.style.opacity='0.85'} onMouseLeave={e=>e.target.style.opacity='1'}
              >{status==='loading'?'...':n.button}</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
